import { render, staticRenderFns } from "./GamayunButton.vue?vue&type=template&id=48927720"
import script from "./GamayunButton.vue?vue&type=script&lang=js"
export * from "./GamayunButton.vue?vue&type=script&lang=js"
import style0 from "./GamayunButton.vue?vue&type=style&index=0&id=48927720&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports